import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./app/App";

const appContainer = document.getElementById("root");
ReactDOM.render(<App />, appContainer);
